import React, { useEffect, useState } from "react";
import "./Sidebar.css";
import SibarChart from "./SibarChart";
import db from "../../../Firebase/Firebase-config";
import { onSnapshot, collection } from "firebase/firestore";

function SideBar() {
  const [rooms, setRooms] = useState([]);

  useEffect(
    () =>
      onSnapshot(collection(db, "rooms"), (snapshot) => {
        setRooms(snapshot.docs);
      })[db]
  );

  return (
    <div className="sidebar">
      <h1>Select a Group Space</h1>
      <p>Enter any of the following group spaces to discuss about your problems with others with similar issues.</p>
      
      <div className="sidebar__chart">
        {rooms.map((room) => (
          <SibarChart key={room.id} id={room.id} name={room.data().name} />
        ))}
      </div>
    </div>
  );
}

export default SideBar;